__turbopack_context__.v({
  "className": "ibm_plex_sans_thai_76a5c036-module__yxHinW__className",
  "variable": "ibm_plex_sans_thai_76a5c036-module__yxHinW__variable",
});
